import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment as ENV } from '@environment/environment';
import { SoaApi } from '@interfaces/i-cancel-subscription';
import { ISetting } from '@interfaces/i-setting.interface';

@Injectable({
  providedIn: 'root'
})
export class SettingSoaService {

  private API = `${ENV.soaApiBaseUrl}Setting`;

  constructor(private http: HttpClient) {}

  getSettings(): Observable<ISetting[]> {
    return this.http.get<SoaApi<ISetting[]>>(this.API)
      .pipe(map(response => response.value || []));
  }

  getGeolocation(): Observable<string> {
    return this.http.get<SoaApi<string>>(`${this.API}/geolocation`)
      .pipe(map(response => response.value || ''));
  }

}

